import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import { withXScrollPositionContext } from "../../components/scrollable/ScrollPositionContext";
import withScrollableView from "../../components/scrollable/withScrollableView";
import {
  // RELATIONSHIP_EVENT_COLUMN_WIDTH,
  RELATIONSHIP_ENTITY_COLUMN_WIDTH,
  RELATIONSHIP_GROUP_LABEL_WIDTH
} from "../../constants";
import { scalePixelsToFontSize } from "../../constants/styles/dimensions";
import { immutableRecords, PropTypeShapes } from "../../types";

class RelationshipScrollBackgroundCanvasView extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  renderChildLines(colGroups) {
    // const SCALED_EVENT_COLUMN_WIDTH = scalePixelsToFontSize(RELATIONSHIP_EVENT_COLUMN_WIDTH, this.props.fontSize);
    const SCALED_GROUP_LABEL_WIDTH = scalePixelsToFontSize(RELATIONSHIP_GROUP_LABEL_WIDTH, this.props.fontSize);
    const SCALED_ENTITY_COLUMN_WIDTH = scalePixelsToFontSize(RELATIONSHIP_ENTITY_COLUMN_WIDTH, this.props.fontSize);

    const leftStart = -1;
    let left = leftStart;
    return colGroups
      .map((g, gIndex) => {
        let colElements = g.cols.map((c, cIndex) => {
          const line = (
            <div
              key={`${gIndex}.${cIndex}`}
              id={`${gIndex}.${cIndex}`}
              className="relationshipBackgroundLine"
              style={{ transform: `translateX(${left}px)` }}
            />
          );
          left += SCALED_ENTITY_COLUMN_WIDTH;
          return line;
        });

        colElements = colElements.push(
          <div
            key={`group-${gIndex}`}
            id={`group-${gIndex}`}
            className="relationshipBackgroundLine"
            style={{ transform: `translateX(${left}px)` }}
          />
        );
        left += SCALED_GROUP_LABEL_WIDTH;
        return colElements;
      })
      .flatten()
      .toArray();
  }

  render() {
    return (
      <div
        className="relationshipScrollBackgroundCanvasView"
        style={{ width: `${this.props.xScrollPosition.viewport.range}px` }}
      >
        {this.renderChildLines(this.props.colGroups)}
      </div>
    );
  }
}

RelationshipScrollBackgroundCanvasView.propTypes = {
  fontSize: PropTypes.number.isRequired,

  colGroups: PropTypeShapes.relationshipColumnGroupList.isRequired,
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,

  // From withScrollPositionContext
  xScrollPosition: PropTypes.instanceOf(immutableRecords.ScrollPositionRecord).isRequired
};

const scrollableViewOptions = {
  scrollHorizontally: true,
  scrollVertically: false,
  showHorizontalScrollbar: false,
  showVerticalScrollbar: false
};

export default withScrollableView(
  withXScrollPositionContext(RelationshipScrollBackgroundCanvasView),
  scrollableViewOptions
);
